import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const opensearch = defineConnector({
  identifier: "opensearch",
  name: "OpenSearch",
  tagLine: "Search and analytics engine",
  logo,
  protocol: "http",
  tags: ["data", "observability"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.es\\.amazonaws\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Use the admin username and password configured for your OpenSearch cluster.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "OpenSearch host",
          placeholder: "search.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Username",
          placeholder: "admin",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/_cluster/health`,
  },
});
